/* YourDTF — refonte 2026 : apparitions, compteurs, frise des étapes, en-tête, inclinaison des tuiles. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function formatNumber(value, decimals) {
    return value.toLocaleString('fr-FR', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
  }

  function runCounter(el) {
    var target = parseFloat(el.getAttribute('data-yd-count'));
    if (isNaN(target)) return;
    var decimals = parseInt(el.getAttribute('data-yd-decimals') || '0', 10);
    var prefix = el.getAttribute('data-yd-prefix') || '';
    var suffix = el.getAttribute('data-yd-suffix') || '';
    if (reduceMotion) {
      el.textContent = prefix + formatNumber(target, decimals) + suffix;
      return;
    }
    var duration = 1600;
    var start = null;
    function frame(now) {
      if (!start) start = now;
      var t = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - t, 4);
      el.textContent = prefix + formatNumber(target * eased, decimals) + suffix;
      if (t < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function initReveal(root) {
    var items = root.querySelectorAll('[data-yd-reveal]:not(.is-in), [data-yd-count]:not([data-yd-counted])');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('is-in');
        if (el.hasAttribute('data-yd-count')) runCounter(el);
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        if (el.hasAttribute('data-yd-count')) {
          el.setAttribute('data-yd-counted', '');
          runCounter(el);
        } else {
          el.classList.add('is-in');
        }
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* La ligne des étapes se remplit au fil du scroll et allume chaque pastille. */
  var stepLists = [];
  function initSteps(root) {
    root.querySelectorAll('[data-yd-steps]').forEach(function (list) {
      if (stepLists.indexOf(list) === -1) stepLists.push(list);
    });
    updateSteps();
  }
  function updateSteps() {
    var vh = window.innerHeight;
    stepLists = stepLists.filter(function (list) { return document.body.contains(list); });
    stepLists.forEach(function (list) {
      var rect = list.getBoundingClientRect();
      var progress = reduceMotion ? 1 : (vh * 0.85 - rect.top) / (vh * 0.5);
      progress = Math.max(0, Math.min(1, progress));
      list.style.setProperty('--progress', progress.toFixed(3));
      var steps = list.querySelectorAll('.yd-step');
      steps.forEach(function (step, i) {
        var threshold = steps.length > 1 ? i / (steps.length - 1) : 0;
        step.classList.toggle('is-done', progress >= threshold - 0.001 && progress > 0);
      });
    });
  }

  /* Légère inclinaison des tuiles catégories qui suit le pointeur. */
  function initTilt(root) {
    if (reduceMotion || !finePointer) return;
    root.querySelectorAll('[data-yd-tilt]').forEach(function (card) {
      if (card.__ydTilt) return;
      card.__ydTilt = true;
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.setProperty('--ry', (x * 6).toFixed(2) + 'deg');
        card.style.setProperty('--rx', (-y * 6).toFixed(2) + 'deg');
      });
      card.addEventListener('pointerleave', function () {
        card.style.setProperty('--ry', '0deg');
        card.style.setProperty('--rx', '0deg');
      });
    });
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      document.documentElement.classList.toggle('yd-scrolled', window.scrollY > 12);
      updateSteps();
      ticking = false;
    });
  }

  function init(root) {
    root = root || document;
    initReveal(root);
    initSteps(root);
    initTilt(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
